import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components'
import Icon from '../../components/Icon'
import { Hr, Text } from '../../elements'

interface IInsightEndedProps {
  chapterTitle: string
  chapterIdx: number
  onClose?: () => void
  onNext?: () => void
  onDiscuss?: () => void
}

const OverlayContainer = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center'
})`
  z-index: 10;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(255, 255, 255, 0.4);
`

const DialogContainer = styled(Flex).attrs({
  flexDirection: 'column',
  flex: 1
})`
  max-width: 400px;
  border-radius: 8px;
  box-shadow: 0 -2px 16px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 12px;
`

const DialogHeaderContainer = styled(Flex).attrs({
  justifyContent: 'space-between'
})`
  height: 48px;
`

const InsightEnded = ({
  chapterTitle,
  chapterIdx,
  onClose,
  onNext,
  onDiscuss
}: IInsightEndedProps) => {
  return (
    <OverlayContainer>
      <DialogContainer>
        <DialogHeaderContainer>
          <Box>
            <Text.SubtitleBold>觀點結束</Text.SubtitleBold>
          </Box>
          <Box>
            <Icon
              type="popup-close"
              onClick={onClose}
              style={{ cursor: 'pointer', width: '24px', height: '24px' }}
            />
          </Box>
        </DialogHeaderContainer>
        <Box mb={12}>
          <Text.Content>
            「觀點 {chapterIdx + 1} {chapterTitle}」
            已經結束囉！快把握時間參與討論，或進入下個觀點
          </Text.Content>
        </Box>
        <Hr />
        <Flex mt={12} justifyContent="flex-end">
          <Box mr={3} width={104}>
            <Button
              basic={true}
              fluid={true}
              size="large"
              onClick={onNext}
              style={{
                border: '1px solid #cdcdcd'
              }}
            >
              下個觀點
            </Button>
          </Box>
          <Box width={104}>
            <Button
              fluid={true}
              color="orange"
              size="large"
              onClick={onDiscuss}
            >
              我要討論
            </Button>
          </Box>
        </Flex>
      </DialogContainer>
    </OverlayContainer>
  )
}

export default InsightEnded



// WEBPACK FOOTER //
// ./src/pages/LectureContentPage/InsightEnded.tsx